import Vue from "vue";
import { CallbackEvent } from '@/core/Utility/CallbackEvent.js';

export function NoInternetModalController () {
    this.msg = '';
    this.tag = '';
    this.btnClose = '';
    this.busModal = new Vue();

    this.cbClose = new CallbackEvent();

    //#region setter
    this.setMsg = function (msg) {
        this.msg = msg;
        return this;
    };
    this.setTag = function (tag) {
        this.tag = tag;
        return this;
    };
    this.setBtnClose = function (btnClose) {
        this.btnClose = btnClose;
        return this;
    };
    this.clearModal = function () {
        this.msg = '';
        this.tag = '';
        this.btnClose = '';
        this.cbClose.clearCallback();

        return this;
    };
    ////#endregion setter

    //#region method
    this.show = function () {
        var config = {
            msg: this.msg,
            tag: this.tag,
            btnClose: this.btnClose
        };
        this.busModal.$emit('show', config);
    };
    this.hide = function () {
        this.busModal.$emit('emit');
    };
    //#endregion
}
